import React, { useState } from "react";
import { CloudArrowUp, Funnel, Plus, Share } from "phosphor-react";
//@MUI
import { Button, Typography, Popover, Box } from "@material-ui/core";
import BreadCrumb from "../../Utilities/BreadCrumb/BreadCrumb.jsx";

import useStyles from "./SequencePageTools.styles.js";
import {
  SortButton,
  ToggleButton,
  FilterButton,
  TableViewToggleButtons,
} from "../../CommonComponents/CommonButtons/CommonButtons.Component.jsx";
import TrackableStats from "../../Utilities/TrackableStats/TrackableStats.jsx";
import AddBulkAddButtons from "../../Utilities/Add&BulkAddButtons/Add&BulkAddButtons.jsx";
import CommonFilterComponent from "../../Utilities/CommonFilterComponent/CommonFilterComponent.jsx";

export default function SequencePageTools(props) {
  const classes = useStyles();

  const [sliderState, setSliderState] = React.useState(0);
  const [openButtonPopover, setOpenButtonPopover] = React.useState(null);
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

  const handleButtonPopoverClick = (event) => {
    setOpenButtonPopover(event.currentTarget);
  };

  const handleButtonPopoverClose = () => {
    setOpenButtonPopover(null);
  };

  React.useEffect(() => {
    if (props.sliderState > 0) {
      setSliderState(props.sliderState);
      sessionStorage.setItem("sliderState", `${sliderState}`);
    } else setSliderState(sessionStorage.getItem("sliderState"));
  }, [props.sliderState, sliderState]);

  if (sessionStorage.getItem("sliderState") === null)
    sessionStorage.setItem("sliderState", 0);

  return (
    <div className={classes.root}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <BreadCrumb />
        <TrackableStats stats={props.sequenceStats} type={"Sequence"} />
        {props.selectedEpi && (
          <div className={classes.filter}>
            <Typography
              style={{ display: "flex", alignItems: "center", gap: "5px" }}
            >
              <Funnel size={20} />
              {props.selectedEpi?.name}
            </Typography>{" "}
            <Typography>
              {props.selectedEpi?.sequence_list?.length} sequences
            </Typography>
          </div>
        )}
      </div>
      <div className={classes.inlineDiv}>
        <TableViewToggleButtons
          isTogglerOn={props.isToggleView}
          handleToggle={props.handleToggleView}
        />
        <div>
          <ToggleButton handleToggler={props.handleToggler} />
        </div>
        <div>
          <FilterButton
            btnActive={props.episodeId}
            openFilterModal={props.handleFilterModal}
          />
        </div>
        <div>
          <SortButton
            onSubmit={props.onSubmit}
            defaultvalue={props.defaultvalue}
          />
        </div>
        <Button
          size="small"
          variant="outlined"
          title="Filter"
          style={{
            border: "2px solid #6C65D9",
            borderRadius: "10px",
            padding: "10px",
            textTransform: "none",
            color: "white",
          }}
          onClick={() => setIsFilterDrawerOpen(true)}
        >
          <Funnel size={20} />
        </Button>
        <Button
          size="small"
          variant="outlined"
          style={{
            border: "2px solid #6C65D9",
            borderRadius: "10px",
            padding: "10px",
            textTransform: "none",
            color: "white",
            "&:hover": {
              border: "2px solid #6C65D9",
              backgroundColor: "#252A38",
            },
          }}
          onClick={props.handleOpenExportModal}
        >
          <Share size={20} />
        </Button>
        <div>
          <Button
            size="small"
            className={classes.sequencePageNewSequenceButton}
            disableElevation
            onClick={handleButtonPopoverClick}
          >
            <Plus className={classes.plusIcon} />
            New
          </Button>
          <AddBulkAddButtons
            openButtonPopover={openButtonPopover}
            handleButtonPopoverClose={handleButtonPopoverClose}
            openNewModal={props.openNewSequenceModal}
            openImportModal={props.openImportModal}
            trackableType="sequence"
          />
        </div>
      </div>
      <CommonFilterComponent
        open={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
        trackableType="sequence"
        projectId={props.projectId}
      />
    </div>
  );
}
